/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _Set from "@babel/runtime-corejs3/core-js-stable/set";

/** @module core/modules/randomizer/get-unique-id */
import { getId } from './get-id.js';
var store = new _Set();
/**
 * @description Generates and return an ID that is guaranteed to be unique during the current process.
 * @param {number} [length] - Generated ID length.
 * @param {string} [customSeed] - Custom seed to be used for random generation.
 * @returns {string} Generated unique ID.
 */

function getUniqueId(length, customSeed) {
  var output = null;

  do {
    output = getId(length, customSeed);
  } while (store.has(output));

  store.add(output);
  return output;
}

export { getUniqueId };